<script>
	// Partials
	import SportsMenu from '@/Partials/Sport/Dashboard/_SportsMenu.svelte';
</script>

<div class="md:w-1/6 md:border-r">
	<SportsMenu />
</div>
